module.exports = __webpack_public_path__ + "static/media/image.fa8d2107.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Blog/GoogleMasterClass/image.jpg
// module id = 76
// module chunks = 0